import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { ActiveAccountComponent } from './components/active-account/active-account.component';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { ForgetPassWordComponent } from './components/forget-pass-word/forget-pass-word.component';
import { CheckedPassWordComponent } from './components/checked-pass-word/checked-pass-word.component';
import { CheckedEmailComponent } from './components/checked-email/checked-email.component';
import { EditPassWordComponent } from './components/edit-pass-word/edit-pass-word.component';
import { AfterUpdatepwdComponent } from './components/after-updatepwd/after-updatepwd.component';


@NgModule({
  declarations: [
    LoginComponent,
    RegisterComponent,
    ActiveAccountComponent,
    ForgetPassWordComponent,
    CheckedPassWordComponent,
    CheckedEmailComponent,
    EditPassWordComponent,
    AfterUpdatepwdComponent
    
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ]
})
export class AuthModule { }
